import { useMemo } from "react";
import { Dimmer, Segment } from "semantic-ui-react";
import FormFooter from "../../../../components/forms/FormFooter";
import styles from "../styles/EditInfo.module.scss";
import { LimitedAccountConfiguration } from "features/Accounts/Configuration/LimitedAccountConfiguration/LimitedAccountConfiguration";
import { type LimitedAccountInfo } from "features/Accounts/types";
import { useFormBinding } from "hooks/useFormBinding";
import cn from "classnames";

export interface EditLimitedInfoOwnProps {
  accountId: number;
  currentConfiguration: LimitedAccountInfo;
  isLoading: boolean;
  isOwnAccount: boolean;
  onInfoUpdated(info: Pick<LimitedAccountInfo, "tags">): void;
  isMobo: boolean;
  hasGlobalAccess: boolean;
  onAddNewTag: (tag: string) => void;
  tags: string[];
}

export const EditLimitedInfo = ({
  currentConfiguration,
  isLoading,
  onInfoUpdated,
  onAddNewTag,
  tags,
}: EditLimitedInfoOwnProps) => {
  const { isDirty, setIsDirty, formRef, handleSubmit, handleReset } = useFormBinding();

  const configuration = useMemo(
    () => ({
      ...currentConfiguration,
      tags: currentConfiguration.tags || [],
    }),
    [currentConfiguration],
  );

  return (
    <>
      <Dimmer.Dimmable as={Segment} dimmed={isLoading} className={cn(styles["container"], "scrollable-content")}>
        <Dimmer active={isLoading} inverted />
        <div className={cn("stretch scrollable-content", "edit-form", styles["account-edit-info"])}>
          <LimitedAccountConfiguration
            ref={formRef}
            currentConfiguration={configuration}
            onDirtyChanged={setIsDirty}
            onSubmit={onInfoUpdated}
            onAddNewTag={onAddNewTag}
            existingTags={tags}
          />
        </div>
      </Dimmer.Dimmable>
      <FormFooter
        isSaveBtnDisabled={!isDirty}
        isCancelBtnDisabled={!isDirty}
        onSave={handleSubmit}
        onCancel={handleReset}
      />
    </>
  );
};
